// 日期+时间
let datetimeParse = function (value) {
  if (!value) {
    return '-'
  }
  return value.replace(/(\S{10})T(\S{5}).*/, '$1 $2')
}
// 日期+时间(精确到秒)
let datetimeSecondParse = function (value) {
  if (!value) {
    return ''
  }
  return value.replace(/(\S{10})T(\S{8}).*/, '$1 $2')
}

// 时间
let timeParse = function (value) {
  if (!value) {
    return ''
  }
  return value.replace(/(\S{10})T(\S{5}).*/, '$1')
}

// 金额
let moneyParse = function (value) {
  if (isNaN(Number(value))) {
    return 'N/A'
  }
  return (Number(value).toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
}

let emptyStr = function (value) {
  if (Object.prototype.toString.call(value) === "[object String]") {
    return value ? value : '-'
  } else {
    return '-'
  }
}
let duration = function (mss) {
  let second = Math.ceil(mss);
  let minute = 0;
  let hour = 0;
  if (second > 0) {
    minute = parseInt(second / 60);
    second = parseInt(second % 60);
    if (minute > 60) {
      hour = parseInt(minute / 60);
      minute = parseInt(minute % 60);
    }
  }
  let time = '';
  if (minute == 0) {
    time += "00:" + parseInt(second);
  } else {
    time += parseInt(second);
  }
  if (minute != 0) {
    if (minute > 9) {
      if (time == 0) {
        time = parseInt(minute) + ":" + time + '0';
      } else {
        time = parseInt(minute) + ":" + time;
      }
    } else {
      time = "0" + parseInt(minute) + ":" + (time > 9 ? time : '0' + time);
    }
  }
  if (hour > 0) {
    time = parseInt(hour) + ":" + time;
  }
  return time;
}

let timeDis = function (direct_time) {
  if (!direct_time) return ''
  // direct_time格式为yyyy-mm-dd hh:mm:ss 指定时间
  var now_time = Date.parse(new Date());//当前时间的时间戳
  var end_time = new Date(datetimeSecondParse(direct_time).replace(/-/g, '/')).getTime();//指定时间的时间戳
  if (now_time < end_time) {
    return '刚刚'
  } else {
    //计算相差天数
    var time_dis = Math.minus(now_time, end_time);
    var days = Math.floor(time_dis / (24 * 3600 * 1000));
    var hours, minutes
    if (days > 0 && days < 30) {
      return days + "天前"
    } else if (days > 30) {
      return timeParse(direct_time)
    }
    if (days === 0) {
      //计算出小时数
      var leave1 = time_dis % (24 * 3600 * 1000);//计算天数后剩余的毫秒数
      hours = Math.floor(leave1 / (3600 * 1000));
    }
    if (hours > 0) return hours + "小时前"
    if (hours === 0) {
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000);//计算小时数后剩余的毫秒数
      minutes = Math.floor(leave2 / (60 * 1000));
    }
    if (minutes > 0) return minutes + "分前"
    if (minutes === 0) return "刚刚"
  }
}
let scoreBehavior = function (value) {
  switch (value) {
    case 8:
      return '订单抵扣'
    case 2:
      return '完善企业信息'
    case 4:
      return '积分充值'
    case 1:
      return '注册赠送'
    case 16:
      return '首单奖励,入账冻结账户'
    case 32:
      return '首单完成,冻结账户转入可用账户'
    case 64:
      return '种子用户'
    case 128:
      return '系统赠送'
    case 16384:
      return '系统扣减'
    case 512:
      return '议价违约'
    case 1024:
      return '取消订单,返还积分'
    case 4096:
      return '完善企业信息（+）入账'
    case 8192:
      return '订单已完成'
    case 256:
      return '订单被放弃,返还积分'
    case 2048:
      return '积分清零'
    case 65536:
      return '签到'
    default:
      return 'N/A'
  }
}

export default {
  timeParse,
  datetimeParse,
  datetimeSecondParse,
  moneyParse,
  emptyStr,
  duration,
  timeDis,
  scoreBehavior
}
